import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Box, Title, Text, Button, Group } from '@mantine/core'

const SuccessPage = () => {
	const { state } = useLocation()
	const navigate = useNavigate()
	const { experienceSlug } = useParams()

	const nextButtonRef = useRef(null)
	const checkIn = state?.checkIn

	useEffect(() => {
		if (nextButtonRef.current) {
			nextButtonRef.current.focus()
		}
	}, [])

	if (!checkIn) {
		return (
			<Box px='md' py='md'>
				<Title order={3} color='red'>
					Oops!
				</Title>
				<Text mt='sm'>No check-in data was found.</Text>
				<Button
					mt='md'
					onClick={() => navigate(`/experiences/${experienceSlug}`)}
				>
					Back to Search
				</Button>
			</Box>
		)
	}

	return (
		<Box px='md' py='md'>
			<Title order={2}>Success!</Title>
			<Text mt='sm'>{checkIn.travelerName} is checked in.</Text>

			<Group mt='lg'>
				<Button
					ref={nextButtonRef}
					onClick={() => navigate(`/experiences/${experienceSlug}`)}
				>
					Next Traveler
				</Button>
				<Button variant='light' onClick={() => navigate(-1)}>
					Go Back
				</Button>
			</Group>
		</Box>
	)
}

export default SuccessPage
